//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ChartServerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Render a chart based on the given request parameters.
     * @param width Width of the chart image (pixels)
     * @param height Height of the chart image (pixels)
     * @param latitude Latitude of the center of the image (degrees)
     * @param longitude Longitude of the center of the image (degrees)
     * @param scale Scale of the chart (applied on top of the dots per meter scaling)
     * @param dpm Dots (pixels) per meter
     * @param rotation Rotation of chart with the center of the image as pivot point
     * @param rotationCenterX (optional) Obsolete, setting this is a no-op
     * @param rotationCenterY (optional) Obsolete, setting this is a no-op
     * @param displayGroups (optional) Show or hide specific display groups, comma separated.
     * @param shallowContour (optional) Shallow contour (meters)
     * @param safetyContour (optional) Safety contour (meters)
     * @param deepContour (optional) Deep contour (meters)
     * @param safetyDepth (optional) Safety depth (meters)
     * @param colourMode (optional) Render contours in 4-colour mode, if false render in 2-colour mode.
     * @return Success
     */
    chart(width: number, height: number, latitude: number, longitude: number, scale: number, dpm: number, rotation: number, rotationCenterX: number | undefined, rotationCenterY: number | undefined, displayGroups: string | undefined, shallowContour: number | undefined, safetyContour: number | undefined, deepContour: number | undefined, safetyDepth: number | undefined, colourMode: boolean | undefined, signal?: AbortSignal | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Chart?";
        if (width === undefined || width === null)
            throw new Error("The parameter 'width' must be defined and cannot be null.");
        else
            url_ += "Width=" + encodeURIComponent("" + width) + "&";
        if (height === undefined || height === null)
            throw new Error("The parameter 'height' must be defined and cannot be null.");
        else
            url_ += "Height=" + encodeURIComponent("" + height) + "&";
        if (latitude === undefined || latitude === null)
            throw new Error("The parameter 'latitude' must be defined and cannot be null.");
        else
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === undefined || longitude === null)
            throw new Error("The parameter 'longitude' must be defined and cannot be null.");
        else
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&";
        if (scale === undefined || scale === null)
            throw new Error("The parameter 'scale' must be defined and cannot be null.");
        else
            url_ += "Scale=" + encodeURIComponent("" + scale) + "&";
        if (dpm === undefined || dpm === null)
            throw new Error("The parameter 'dpm' must be defined and cannot be null.");
        else
            url_ += "Dpm=" + encodeURIComponent("" + dpm) + "&";
        if (rotation === undefined || rotation === null)
            throw new Error("The parameter 'rotation' must be defined and cannot be null.");
        else
            url_ += "Rotation=" + encodeURIComponent("" + rotation) + "&";
        if (rotationCenterX === null)
            throw new Error("The parameter 'rotationCenterX' cannot be null.");
        else if (rotationCenterX !== undefined)
            url_ += "RotationCenterX=" + encodeURIComponent("" + rotationCenterX) + "&";
        if (rotationCenterY === null)
            throw new Error("The parameter 'rotationCenterY' cannot be null.");
        else if (rotationCenterY !== undefined)
            url_ += "RotationCenterY=" + encodeURIComponent("" + rotationCenterY) + "&";
        if (displayGroups === null)
            throw new Error("The parameter 'displayGroups' cannot be null.");
        else if (displayGroups !== undefined)
            url_ += "DisplayGroups=" + encodeURIComponent("" + displayGroups) + "&";
        if (shallowContour === null)
            throw new Error("The parameter 'shallowContour' cannot be null.");
        else if (shallowContour !== undefined)
            url_ += "ShallowContour=" + encodeURIComponent("" + shallowContour) + "&";
        if (safetyContour === null)
            throw new Error("The parameter 'safetyContour' cannot be null.");
        else if (safetyContour !== undefined)
            url_ += "SafetyContour=" + encodeURIComponent("" + safetyContour) + "&";
        if (deepContour === null)
            throw new Error("The parameter 'deepContour' cannot be null.");
        else if (deepContour !== undefined)
            url_ += "DeepContour=" + encodeURIComponent("" + deepContour) + "&";
        if (safetyDepth === null)
            throw new Error("The parameter 'safetyDepth' cannot be null.");
        else if (safetyDepth !== undefined)
            url_ += "SafetyDepth=" + encodeURIComponent("" + safetyDepth) + "&";
        if (colourMode === null)
            throw new Error("The parameter 'colourMode' cannot be null.");
        else if (colourMode !== undefined)
            url_ += "ColourMode=" + encodeURIComponent("" + colourMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "image/png"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processChart(_response);
        });
    }

    protected processChart(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Retrieve chart object info for a certain position.
     * @param body Body requires the geo position and the scale level.
     * @return Success
     */
    objectInfo(body: ObjectInfoBody, signal?: AbortSignal | undefined): Promise<ObjectInfo[]> {
        let url_ = this.baseUrl + "/Chart/objectInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processObjectInfo(_response);
        });
    }

    protected processObjectInfo(response: Response): Promise<ObjectInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ObjectInfo[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Validate (part of) a route. This method will first calculate the area segments that are covered by the given route.
    Then it will query the charts for warning and grounding data, and return a list of waypoint results
    with grounding and warning features for each waypoint leg and (optional) turn. Using Start/EndWaypoint in the body, 
    it's possible to limit the validated part of the route.
     * @param body Body requires route to validate and start/end waypoint index. The route must contain at least 2 waypoints.
     * @return Success
     */
    validate(body: ValidateBody, signal?: AbortSignal | undefined): Promise<RouteValidationResult> {
        let url_ = this.baseUrl + "/Route/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidate(_response);
        });
    }

    protected processValidate(response: Response): Promise<RouteValidationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RouteValidationResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not Modified", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * Calculate visual representation of a route for the frontend.
     * @param body Route to calculate, must contain at least 2 waypoints.
     * @return Success
     */
    calculate(body: Route, signal?: AbortSignal | undefined): Promise<RouteCalculationResult> {
        let url_ = this.baseUrl + "/Route/calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalculate(_response);
        });
    }

    protected processCalculate(response: Response): Promise<RouteCalculationResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RouteCalculationResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export interface CriticalPoint {
    criticalPointId?: string;
    waypointId?: string;
    distanceFromWaypoint?: number;
    monitoringMode?: MonitoringMode;
    triggerValue?: number;
    message?: string | undefined;
    persist?: boolean;
}

export interface DistanceMarker {
    position?: LatLon;
    direction?: number;
}

export interface DistanceMarkerConfiguration {
    distance?: number;
    reversed?: boolean;
}

export interface EnrichedCriticalPoint {
    criticalPointId?: string;
    waypointId?: string;
    distanceFromWaypoint?: number;
    monitoringMode?: MonitoringMode;
    triggerValue?: number;
    message?: string | undefined;
    persist?: boolean;
}

export interface EnrichedWaypoint {
    waypointId?: string;
    latitude?: number;
    longitude?: number;
    turnRadius?: number;
    speed?: number;
    leg?: Leg;
    edge?: LatLon[] | undefined;
    track?: LatLon[] | undefined;
    starboardXtdTrack?: LatLon[] | undefined;
    portXtdTrack?: LatLon[] | undefined;
    distance?: number;
    time?: number;
    course?: number;
    turnData?: TurnData;
    hasBadGeometry?: boolean;
}

export interface Feature {
    id?: string | undefined;
    properties?: Property[] | undefined;
}

export interface GeoPosition {
    longitude?: number;
    latitude?: number;
}

export interface Geometry {
    points?: LatLon[] | undefined;
    id?: string | undefined;
}

export interface GroundingData {
    polygons?: Polygons;
    groundings?: Feature[] | undefined;
    warnings?: Feature[] | undefined;
}

export interface LatLon {
    latitude?: number;
    longitude?: number;
}

export interface Leg {
    starboardSideXtd?: number;
    portSideXtd?: number;
    projection?: Projection;
}

export enum MonitoringMode {
    Time = "time",
    Distance = "distance",
}

export interface ObjectInfo {
    id?: string | undefined;
    points?: LatLon[] | undefined;
    properties?: Property[] | undefined;
}

export interface ObjectInfoBody {
    position: GeoPosition;
    /** Scale level to take in account for determining objects */
    scale: number;
}

export interface Polygons {
    groundingPolygons?: Geometry[] | undefined;
    warningPolygons?: Geometry[] | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export enum Projection {
    GreatCircle = "greatCircle",
    RhumbLine = "rhumbLine",
}

export interface Property {
    title?: string | undefined;
    value?: string | undefined;
}

export interface Route {
    safetyContour?: number;
    waypoints?: Waypoint[] | undefined;
    distanceMarkerConfiguration?: DistanceMarkerConfiguration;
    criticalPoints?: CriticalPoint[] | undefined;
}

export interface RouteCalculationResult {
    waypoints?: EnrichedWaypoint[] | undefined;
    distanceMarkers?: DistanceMarker[] | undefined;
    criticalPoints?: EnrichedCriticalPoint[] | undefined;
}

export interface RouteValidationResult {
    valid?: boolean;
    readonly waypointResults?: WaypointValidationResult[] | undefined;
}

export interface TurnData {
    startPosition?: LatLon;
    centrePosition?: LatLon;
    endPosition?: LatLon;
}

export interface ValidateBody {
    route: Route;
    /** Start validation at waypoint index, 0-based. */
    startWaypoint: number;
    /** End validation at waypoint index (inclusive), 0-based. */
    endWaypoint: number;
}

export interface Waypoint {
    waypointId?: string;
    latitude?: number;
    longitude?: number;
    turnRadius?: number;
    speed?: number;
    leg?: Leg;
}

export interface WaypointValidationResult {
    valid?: boolean;
    waypointNumber?: number;
    data?: GroundingData[] | undefined;
    coverage?: LatLon[][] | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}